import { render, staticRenderFns } from "./lc-editor-header.vue?vue&type=template&id=b676d65e"
import script from "./lc-editor-header.vue?vue&type=script&lang=js"
export * from "./lc-editor-header.vue?vue&type=script&lang=js"
import style0 from "./lc-editor-header.vue?vue&type=style&index=0&id=b676d65e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports